/*
 *
 * DashboardFilters constants
 *
 */

import moment from 'moment';

const BASE_ACTION_CONSTANT = 'app/DashboardFilters';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const SET_ACTIVE_NAVIGATION = `${BASE_ACTION_CONSTANT}/SET_ACTIVE_NAVIGATION`;

export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const DISABLE_CHECKBOX = ['Disputes'];

export const EXCLUDED_FILTERS = {
  Disputes: ['OVERDUE', 'DUE_IMMEDIATE_WEEKEND'],
};

export const CURRENT_DATE_RANGE_BATCH = [
  {
    displayText: 'All time',
    range: [
      moment()
        .subtract(365, 'day')
        .toDate(),
      moment()
        .add(180, 'day')
        .toDate(),
    ],
  },
  {
    displayText: 'Today',
    range: [
      moment()
        .startOf('day')
        .toDate(),
      moment()
        .endOf('day')
        .toDate(),
    ],
  },
  {
    displayText: 'This Month',
    range: [
      moment()
        .startOf('month')
        .toDate(),
      moment()
        .endOf('month')
        .toDate(),
    ],
  },
];

export const PREV_DATE_RANGE_BATCH = [
  {
    displayText: 'Last 24 hours',
    range: [
      moment()
        .subtract(24, 'hours')
        .toDate(),
      moment().toDate(),
    ],
  },
  {
    displayText: 'Last 48 hours',
    range: [
      moment()
        .subtract(48, 'hours')
        .toDate(),
      moment().toDate(),
    ],
  },
  {
    displayText: 'Last 7 days',
    range: [
      moment()
        .subtract(6, 'days')
        .toDate(),
      moment().toDate(),
    ],
  },
  {
    displayText: 'Last Month',
    range: [
      moment()
        .subtract(1, 'month')
        .startOf('month')
        .toDate(),
      moment()
        .subtract(1, 'month')
        .endOf('month')
        .toDate(),
    ],
  },
];

export const NEXT_DATE_RANGE_BATCH = [
  {
    displayText: 'Next 24 hours',
    range: [
      moment().toDate(),
      moment()
        .add(24, 'hours')
        .toDate(),
    ],
  },
  {
    displayText: 'Next 48 hours',
    range: [
      moment().toDate(),
      moment()
        .add(48, 'hours')
        .toDate(),
    ],
  },
  {
    displayText: 'Next 7 days',
    range: [
      moment().toDate(),
      moment()
        .add(6, 'days')
        .endOf('day')
        .toDate(),
    ],
  },
  {
    displayText: 'Next Month',
    range: [
      moment()
        .add(1, 'month')
        .startOf('month')
        .toDate(),
      moment()
        .add(1, 'month')
        .endOf('month')
        .toDate(),
    ],
  },
];

export const EASY_SPLIT = 'EASY_SPLIT';

export const EASY_SPLIT_ALL = 'EASY_SPLIT_ALL';

export const NEW_FLOW = 'NEW_FLOW';

export const OLD_FLOW = 'OLD_FLOW';
